import { Link } from "react-router-dom";
import Header from "../Components/header";
const NotFound = () => {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="white flex flex-col items-center justify-center h-full">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-lg mb-4">Pagina non trovata.</p>
        <Link to="/" className="underline">
          Torna alla homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
